import { defineComponent as _defineComponent } from 'vue'
import { LatLng } from '@/models/LatLng'
import { computed, PropType } from "vue"
import { useTheme } from "@/composables/useTheme"


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesBotMapRouteLine',
  props: {
  path: {
    type: Array as PropType<LatLng[]>,
    default: () => [],
  },
},
  setup(__props) {

const props = __props;

const STROKE_OPACITY = 1
const STROKE_WEIGHT = 4
const { themes } = useTheme()



const routeLineOptions = computed(() => ({
  strokeOpacity: STROKE_OPACITY,
  strokeWeight: STROKE_WEIGHT,
  strokeColor: themes?.value?.light?.midnightGray900 || ''
}))

return { __sfc: true,STROKE_OPACITY, STROKE_WEIGHT, themes, props, routeLineOptions }
}

})